// eslint-disable-next-line import/no-unresolved
import { Layout, PlotData } from 'plotly.js-basic-dist';
import { getY2TraceConfig, getYTraceConfig, plotLayoutConfig } from '../RiskProductsWidget.presentational.constants';

const traceCQS: Partial<PlotData> = getYTraceConfig('CQS');
const traceACR: Partial<PlotData> = getY2TraceConfig('ACR');

export const plotDefaultData: Partial<PlotData>[] = [traceCQS, traceACR];
export const plotDefaultLayout: Partial<Layout> = plotLayoutConfig;

export const infoTooltipText =
  'The Credit Quality Score (CQS) can be used to identify companies with upgrade or downgrade potential. The higher the CQS, the higher the medium-term credit quality of the company (ACR is the agency composite rating).';
